import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    groupedByCell: {
      fontWeight: 'bold',
    },
    emptyReportMessageContainer: {
      marginTop: 140,

      '@media (max-width: 413px)': {
        marginTop: 98.5,
      },
    },
    button: {
      borderRadius: 25,
      padding: '10px 20px 10px 20px',
    },
    reportTable: {
      marginTop: '18px',
      '@media (max-width: 1023px)': {
        display: 'none',
      },
    },
    login: {
      borderRadius: '15px 0 0 15px',

      '@media (max-width: 600px)': {
        padding: '5px 8px !important;',

        '& .MuiButton-label': {
          fontSize: 13,
        },
      },
    },
    symbolCategory: {
      borderRadius: 0,

      '@media (max-width: 600px)': {
        padding: '5px 8px !important;',

        '& .MuiButton-label': {
          fontSize: 13,
        },
      },
    },
    symbol: {
      borderRadius: '0 15px 15px 0',

      '@media (max-width: 600px)': {
        padding: '5px 8px !important;',

        '& .MuiButton-label': {
          fontSize: 13,
        },
      },
    },
    selectedGroup: {
      backgroundColor: variables.cultured,
    },
    quickReports: {
      maxWidth: '33.3%',
      flexBasis: '33.3%',
      borderRight: `0.5px solid ${variables.black10}`,

      '@media (max-width: 1180px)': {
        width: 250,
        maxWidth: 250,
        flexBasis: 'unset',
        display: 'inline-block',
      },
    },
    panels: {
      marginTop: 16,
      marginBottom: 16,

      '@media (max-width: 1180px)': {
        display: 'block',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
      },
    },
    emptyCell: {
      minWidth: 65,
      maxWidth: 65,
      width: 65,
    },
    cell: {
      minWidth: 153,
      maxWidth: 153,
      padding: '6px 16px',
    },
  }),
);
